import TagManager from 'react-gtm-module';
import { config } from 'config';
import { isProd } from 'app/utils/utils';

const tagManagerArgsProd = {
  gtmId: config.GTM.ID,
};

const tagManagerArgsDev = {
  gtmId: config.GTM.ID,
  preview: config.GTM.DEV_PREVIEW,
  auth: config.GTM.DEV_AUTH,
};

export const initializeGoogleTagManager = () => {
  TagManager.initialize(isProd() ? tagManagerArgsProd : tagManagerArgsDev);
};
